import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudentsStatics.vue?vue&type=template&id=3caefa8f&"
import script from "./MoleculeEditionAssetSignedStudentsStatics.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudentsStatics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports